export default {
	OPENAI_API_KEY : "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",
	OPENAI_API_ORGANIZATION : "org-SlQlFRUonUBKpOY8oWPis0ef",
	API_URL:
		process.env.NODE_ENV === "production"
			? "https://edc.org.kw/?rest_route=/edc/v1/"
			: "https://edc.org.kw/?rest_route=/edc/v1/",//"http://localhost/edc/?rest_route=/edc/v1/",
};

